import http from "./http";

let parseVars = (srcs, funid, menuid, defaulttablename, inparas) => {
    if (!(srcs instanceof Array)) {
        srcs = [srcs];
    }
    return http
        .post(
            "./api/common/framecore/loadVar",
            {
                data: srcs,
                funid,
                menuid,
                defaulttablename,
                inparas
            },
            {
                showError: true,
                showSuccess: false
            }
        )
        .then(({ success, data, errMsg }) => {
            if (success) {
                return Promise.resolve(data.data);
            }
        });
};
let parseVar = (src, funid, menuid, defaulttablename, inparas) => {
    if (!(src instanceof Array)) {
        return parseVars(src, funid, menuid, defaulttablename, inparas)[src];
    }
    return parseVars(src, funid, menuid, defaulttablename, inparas);
};
let loadObjVars = (varids, funid, menuid, defaulttablename, inparas) => {
    if (!(varids instanceof Array)) {
        varids = [varids];
    }
    return http
        .post(
            "./api/common/framecore/loadObjVar",
            {
                data: varids,
                funid,
                menuid,
                defaulttablename,
                inparas
            },
            {
                showError: true,
                showSuccess: false
            }
        )
        .then(({ success, data, errMsg }) => {
            if (success) {
                return Promise.resolve(data.data);
            }
        });
};
let loadObjVar = (varid, funid, menuid, defaulttablename, inparas) => {
    if (!(varid instanceof Array)) {
        return loadObjVars(varid, funid, menuid, defaulttablename, inparas)[varid];
    }
    return loadObjVars(varid, funid, menuid, defaulttablename, inparas);
};
let handleNewBillCode = (billcodeid, funid, menuid, defaulttablename, inparas) => {
    return http
        .post(
            "./api/common/framecore/handleNewBillCode",
            {
                billcodeid,
                funid,
                menuid,
                defaulttablename,
                inparas
            },
            {
                showError: true,
                showSuccess: false
            }
        )
        .then(({ success, data, errMsg }) => {
            if (success) {
                return Promise.resolve(data.data);
            }
        });
};
let handleNewBillCodeForRegister = (billcodeid, funid, menuid, defaulttablename, inparas) => {
    return http
        .post(
            "./api/jsaec/register/handleNewBillCode",
            {
                billcodeid,
                funid,
                menuid,
                defaulttablename,
                inparas
            },
            {
                showError: true,
                showSuccess: false
            }
        )
        .then(({ success, data, errMsg }) => {
            if (success) {
                return Promise.resolve(data.data);
            }
        });
};
let doOperCheck = (no, sn, funid, menuid, defaulttablename, inparas, resultparser) => {
    return http
        .post(
            "./api/common/framecore/handleNewBillCode",
            {
                no,
                sn,
                funid,
                menuid,
                defaulttablename,
                inparas,
                resultparser
            },
            {
                showError: true,
                showSuccess: false
            }
        )
        .then(({ success, data, errMsg }) => {
            if (success) {
                return Promise.resolve(data.data);
            }
        });
};

export default {
    /**
     * 批量解析变量
     * @param srcs 变量数组
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    parseVars,
    /**
     * 解析变量
     * @param src 变量号
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    parseVar,
    /**
     * 批量解析对象变量
     * @param varids 变量数组
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    loadObjVars,
    /**
     * 解析对象变量
     * @param varid 变量号
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    loadObjVar,
    /**
     * 生成单据编号
     * @param billcodeid 单据编号id
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    handleNewBillCode,
    /**
     * 生成单据编号-注册无授权
     * @param billcodeid 单据编号id
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @returns {Promise<any>}
     */
    handleNewBillCodeForRegister,
    /**
     * 执行业务验证
     * @param no 验证号
     * @param sn 序号
     * @param funid 功能id，变量解析参数
     * @param menuid 菜单id，变量解析参数
     * @param defaulttablename 默认表名，变量解析参数
     * @param inparas  输入参数，变量解析参数
     * @param resultparser  结果解析实现（类路径）
     * @returns {Promise<any>}
     */
    doOperCheck
};
